<template>
    <form v-if="reel">

        <div class="row">
            <div class="col-md-12">
                <!-- Custom Tabs -->
                <div class="nav-tabs-custom">
                    <ul class="nav nav-tabs">
                        <li class="active"><a href="#tab_1" data-toggle="tab">Identificazione bobina</a></li>
                        <li><a href="#tab_4" data-toggle="tab">Descrizione bobina</a></li>
                        <li>
                            <a href="#tab_2" data-toggle="tab">Restauro conservativo e digitalizzazione</a>
                        </li>
                      <li><a href="#tab_3" data-toggle="tab">Archivio web</a></li>

                        <li class="pull-right" v-show="showSave">
                            <button class="btn btn-success btn-block" v-if="!disabled" v-on:click.prevent="save">
                                <i class="fa fa-circle-o-notch fa-spin" v-if="loader"></i>
                                Salva
                            </button>

                            <button class="btn btn-warning btn-block" v-on:click.prevent="activateMod"
                                    v-if="disabled && $accessControl.isOperator($store.state.profile.profile)">
                                Attiva modifiche
                            </button>
                        </li>

                        <li class="pull-right" v-show="showSearch">
                            <button class="btn btn-success btn-block" v-if="!disabled" v-on:click.prevent="search">
                                <i class="fa fa-circle-o-notch fa-spin" v-if="loader"></i>
                                Cerca
                            </button>
                        </li>

                    </ul>

                    <div class="tab-content">
                        <div class="tab-pane active" id="tab_1">

                            <div class="row">
                                <div class="col-md-6">

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="titolo_originale">Titolo proprio</label>
                                                <input type="text" class="form-control" id="titolo_originale"
                                                       name="titolo_originale"
                                                       v-model="reel.titolo_originale" :disabled="disabled">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="titolo_attribuito">Titolo attribuito</label>
                                                <input type="text" class="form-control" id="titolo_attribuito"
                                                       name="titolo_attribuito"
                                                       v-model="reel.titolo_attribuito" :disabled="disabled">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-9">
                                            <div class="form-group">
                                                <label for="anno_inizio">Anno inizio</label>
                                                <input type="text" class="form-control" id="anno_inizio"
                                                       name="anno_inizio"
                                                       v-model="reel.description.data.anno_inizio" :disabled="disabled">
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label>Data attribuita</label>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox"
                                                               v-model="reel.description.data.anno_inizio_attribuito"
                                                               :disabled="disabled">
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-9">
                                            <div class="form-group">
                                                <label for="anno_fine">Anno fine</label>
                                                <input type="text" class="form-control" id="anno_fine"
                                                       name="anno_fine"
                                                       v-model="reel.description.data.anno_fine" :disabled="disabled">
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label>Data attribuita</label>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox"
                                                               v-model="reel.description.data.anno_fine_attribuito"
                                                               :disabled="disabled">
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="filmFormats">Formato/i</label>

                                                <multiselect
                                                        v-model="reel.filmFormats.data"
                                                        :options="formati"
                                                        :multiple="true"
                                                        track-by="id"
                                                        label="name"
                                                        placeholder="seleziona"
                                                        SelectLabel="seleziona"
                                                        SelectedLabel="selezionato"
                                                        DeselectLabel="deseleziona"
                                                        id="filmFormats"
                                                        name="filmFormats"
                                                        :disabled="disabled">
                                                </multiselect>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="suono">Suono</label>
                                                <select v-model="reel.description.data.suono" class="form-control"
                                                        id="suono"
                                                        name="suono" :disabled="disabled">
                                                    <option></option>
                                                    <option v-for="(suono, id) in ynp"
                                                            v-bind:value="id">
                                                        {{ suono }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="cromatismo">Cromatismo</label>
                                                <select v-model="reel.description.data.cromatismo" class="form-control"
                                                        id="cromatismo"
                                                        name="cromatismo" :disabled="disabled">
                                                    <option></option>
                                                    <option v-for="(cromatismo, id) in cromatismi"
                                                            v-bind:value="id">
                                                        {{ cromatismo }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="durata">Durata totale bobina (h/m/s)</label>
                                                <masked-input v-model="reel.durata" mask="11:11:11"
                                                              placeholder="00:00:00" class="form-control" id="durata"
                                                              name="durata" :disabled="disabled"/>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="lunghezza">Lunghezza</label>
                                                <input type="text" class="form-control" id="lunghezza"
                                                       name="lunghezza"
                                                       v-model="reel.lunghezza" :disabled="disabled">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label>Tipologia</label>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox"
                                                               v-model="reel.description.data.tipo_famiglia"
                                                               :disabled="disabled">
                                                        Famiglia
                                                    </label>
                                                </div>

                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox"
                                                               v-model="reel.description.data.tipo_amatoriale"
                                                               :disabled="disabled">
                                                        Amatoriale
                                                    </label>
                                                </div>

                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox"
                                                               v-model="reel.description.data.tipo_edizione"
                                                               :disabled="disabled">
                                                        Edizione
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="file_master_dimensione">Dimensione file master</label>
                                                <input type="text" class="form-control" id="file_master_dimensione"
                                                       name="file_master_dimensione"
                                                       v-model="reel.file_master_dimensione" :disabled="disabled">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="file_copia_dimensione">Dimensione file copia</label>
                                                <input type="text" class="form-control" id="file_copia_dimensione"
                                                       name="file_copia_dimensione"
                                                       v-model="reel.file_copia_dimensione" :disabled="disabled">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="note_r">Note</label>
                                                <textarea v-model="reel.note" class="form-control" id="note_r"
                                                          name="note_r"
                                                          :disabled="disabled"></textarea>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="catalogato">Catalogato?</label>
                                                <select v-model="reel.catalogato" class="form-control"
                                                        id="catalogato"
                                                        name="catalogato" :disabled="disabled">
                                                    <option></option>
                                                    <option v-for="(desc, id) in ynp"
                                                            v-bind:value="id">
                                                        {{ desc }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!--image handle-->
                                <div class="col-md-6" v-if="showLabels">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <ul id="gallery">
                                                <li v-for="image in reel.reelimages.data">
                                                    <a :href="image.url" target="_blank">
                                                        <img :src="image.url"
                                                             class="img-responsive"/>
                                                    </a>

                                                    <button class="btn btn-xs btn-danger"
                                                            v-on:click.prevent="delImage(image.id)"
                                                            v-show="!disabled">
                                                        <i class="fa fa-remove"></i>
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <dropzone :style="{ border: '2px dashed', height: '200px', width: '100%' }"
                                                      :uploader="uploader" v-show="!disabled"/>
                                            <span class="text-bold"
                                                  v-show="!disabled">Trascina qui i file da caricare</span>
                                        </div>
                                    </div>
                                </div>
                                <!--/.image-handle-->
                            </div>
                        </div>
                        <!-- /.tab-pane -->

                        <div class="tab-pane" id="tab_4">
                            <div class="row">
                                <div class="col-md-6">
                                    <description :description="reel.description.data"
                                                 :disabled="disabled" :reel-description="true"></description>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="abstract">Descrizione contenuto bobina</label>
                                                <textarea v-model="reel.abstract" class="form-control" id="abstract"
                                                          name="abstract"
                                                          :disabled="disabled"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <!-- /.tab-pane -->

                        <div class="tab-pane" id="tab_2">
                            <div class="row">
                                <div class="col-md-6">

                                    <div class="row">
                                        <div class="col-md-12">
                                            <h4>Stato fisico del film</h4>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">

                                                <label for="filmBrands">Marca pellicola</label>
                                                <multiselect
                                                        v-model="reel.filmBrands.data"
                                                        :options="brands"
                                                        :multiple="true"
                                                        track-by="id"
                                                        label="name"
                                                        placeholder="seleziona"
                                                        SelectLabel="seleziona"
                                                        SelectedLabel="selezionato"
                                                        DeselectLabel="deseleziona"
                                                        id="filmBrands"
                                                        name="filmBrands"
                                                        :disabled="disabled">
                                                </multiselect>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="audio">Pista sonora</label>
                                                <select v-model="reel.restoration.data.audio" class="form-control"
                                                        id="audio"
                                                        name="audio" :disabled="disabled">
                                                    <option></option>
                                                    <option v-for="(a, id) in audio"
                                                            v-bind:value="id">
                                                        {{ a }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="audio_note_d">Note pista sonora</label>
                                                <textarea v-model="reel.restoration.data.audio_note"
                                                          class="form-control"
                                                          id="audio_note_d"
                                                          name="audio_note_d"
                                                          :disabled="disabled"></textarea>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="sindrome_aceto">Sindrome dell'aceto</label>
                                                <select v-model="reel.restoration.data.sindrome_aceto"
                                                        class="form-control"
                                                        id="sindrome_aceto"
                                                        name="sindrome_aceto" :disabled="disabled">
                                                    <option></option>
                                                    <option v-for="(desc, id) in ynp"
                                                            v-bind:value="id">
                                                        {{ desc }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="colore_decaduto">Decadimento colore</label>
                                                <select v-model="reel.restoration.data.colore_decaduto"
                                                        class="form-control"
                                                        id="colore_decaduto"
                                                        name="colore_decaduto" :disabled="disabled">
                                                    <option></option>
                                                    <option v-for="(desc, id) in ynp"
                                                            v-bind:value="id">
                                                        {{ desc }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="sporco">Polvere/sporco</label>
                                                <select v-model="reel.restoration.data.sporco" class="form-control"
                                                        id="sporco"
                                                        name="sporco" :disabled="disabled">
                                                    <option></option>
                                                    <option v-for="(desc, id) in ynp"
                                                            v-bind:value="id">
                                                        {{ desc }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="tipologia_giunte">Tipologia giunte</label>
                                                <select v-model="reel.restoration.data.tipologia_giunte"
                                                        class="form-control"
                                                        id="tipologia_giunte"
                                                        name="tipologia_giunte" :disabled="disabled">
                                                    <option></option>
                                                    <option v-for="(joint, id) in joints"
                                                            v-bind:value="id">
                                                        {{ joint }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="restringimento">Restringimento longitudinale</label>
                                                <select v-model="reel.digitazion.data.restringimento"
                                                        class="form-control"
                                                        id="restringimento"
                                                        name="restringimento" :disabled="disabled">
                                                    <option></option>
                                                    <option v-for="(desc, id) in longitudinalNarrowing"
                                                            v-bind:value="id">
                                                        {{ desc }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="note">Note</label>
                                                <textarea v-model="reel.restoration.data.note"
                                                          class="form-control"
                                                          id="note"
                                                          name="note" :disabled="disabled">
                                            </textarea>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="info_scatola">Informazioni contenitore originale</label>
                                                <textarea v-model="reel.restoration.data.info_scatola"
                                                          class="form-control"
                                                          id="info_scatola"
                                                          name="info_scatola" :disabled="disabled">
                                            </textarea>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="restorers">Operatore/i</label>
                                                <multiselect
                                                        v-model="reel.restoration.data.filmAnalyzers.data"
                                                        :options="persons"
                                                        :multiple="true"
                                                        track-by="id"
                                                        label="nome"
                                                        placeholder="seleziona"
                                                        SelectLabel="seleziona"
                                                        SelectedLabel="selezionato"
                                                        DeselectLabel="deseleziona"
                                                        id="filmAnalyzers"
                                                        name="filmAnalyzers"
                                                        :disabled="disabled"
                                                        :clear-on-select="false"
                                                        :searchable="true"
                                                        @search-change="personsFind">
                                                </multiselect>

                                            </div>
                                        </div>
                                    </div>


                                    <div class="row">
                                        <div class="col-md-12">
                                            <h4>Interventi di ripristino</h4>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label>Restauro eseguito?</label>
                                                <select v-model="reel.restauro" class="form-control"
                                                        id="restauro"
                                                        name="restauro" :disabled="disabled">
                                                    <option></option>
                                                    <option v-for="(desc, id) in ynp"
                                                            v-bind:value="id">
                                                        {{ desc }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="data_rest">Data primo intervento</label>
                                                <date-picker class="form-control" id="data_rest"
                                                             name="data_digit"
                                                             v-model="reel.restoration.data.data" @dp-error="error"
                                                             :config="config"
                                                             :disabled="disabled"></date-picker>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="ult_rev_data">Data ulteriori interventi</label>
                                                <date-picker class="form-control" id="ult_rev_data"
                                                             name="data_digit"
                                                             v-model="reel.restoration.data.ult_rev_data"
                                                             @dp-error="error"
                                                             :config="config"
                                                             :disabled="disabled"></date-picker>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="pulizia">Pulizia pellicola effettuata</label>
                                                <select v-model="reel.restoration.data.pulizia" class="form-control"
                                                        id="pulizia"
                                                        name="pulizia" :disabled="disabled">
                                                    <option></option>
                                                    <option v-for="(desc, id) in ynp"
                                                            v-bind:value="id">
                                                        {{ desc }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="giunte_ripristinate">Giunte ripristinate</label>
                                                <input type="text" class="form-control" id="giunte_ripristinate"
                                                       name="giunte_ripristinate"
                                                       v-model="reel.restoration.data.giunte_ripristinate"
                                                       :disabled="disabled">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="fotogrammi_rimossi">Fotogrammi rimossi</label>
                                                <input type="text" class="form-control" id="fotogrammi_rimossi"
                                                       name="fotogrammi_rimossi"
                                                       v-model="reel.restoration.data.fotogrammi_rimossi"
                                                       :disabled="disabled">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="interventi_note">Note</label>
                                                <textarea v-model="reel.restoration.data.interventi_note"
                                                          class="form-control"
                                                          id="interventi_note"
                                                          name="interventi_note" :disabled="disabled">
                                            </textarea>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="restorers">Operatore/i</label>
                                                <multiselect
                                                        v-model="reel.restoration.data.restorers.data"
                                                        :options="persons"
                                                        :multiple="true"
                                                        track-by="id"
                                                        label="nome"
                                                        placeholder="seleziona"
                                                        SelectLabel="seleziona"
                                                        SelectedLabel="selezionato"
                                                        DeselectLabel="deseleziona"
                                                        id="restorers"
                                                        name="restorers"
                                                        :disabled="disabled"
                                                        :clear-on-select="false"
                                                        :searchable="true"
                                                        @search-change="personsFind">
                                                </multiselect>

                                            </div>
                                        </div>
                                    </div>


                                    <div class="row">
                                        <div class="col-md-12">
                                            <h4>Digitalizzazione</h4>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label>Digitalizzazione eseguita?</label>
                                                <select v-model="reel.digit" class="form-control"
                                                        id="digit"
                                                        name="digit" :disabled="disabled">
                                                    <option></option>
                                                    <option v-for="(desc, id) in ynp"
                                                            v-bind:value="id">
                                                        {{ desc }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="data_digit">Data digitalizzazione</label>
                                                <date-picker class="form-control" id="data_digit"
                                                             name="data_digit"
                                                             v-model="reel.digitazion.data.data" @dp-error="error"
                                                             :config="config"
                                                             :disabled="disabled"></date-picker>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="freq1">Frame rate</label>
                                                <select v-model="reel.digitazion.data.freq1" class="form-control"
                                                        id="freq1"
                                                        name="freq1" :disabled="disabled">
                                                    <option></option>
                                                    <option v-for="(freq, id) in freq1"
                                                            v-bind:value="id">
                                                        {{ freq }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="velocita">Velocità scansione</label>
                                                <select v-model="reel.digitazion.data.velocita" class="form-control"
                                                        id="velocita"
                                                        name="freq1" :disabled="disabled">
                                                    <option></option>
                                                    <option v-for="(velocita, id) in velocity"
                                                            v-bind:value="id">
                                                        {{ velocita }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="note_d">Note</label>
                                                <textarea v-model="reel.digitazion.data.note" class="form-control"
                                                          id="note_d"
                                                          name="note_d"
                                                          :disabled="disabled"></textarea>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="digiters">Operatore/i</label>
                                                <multiselect
                                                        v-model="reel.digitazion.data.digiters.data"
                                                        :options="persons"
                                                        :multiple="true"
                                                        track-by="id"
                                                        label="nome"
                                                        placeholder="seleziona"
                                                        SelectLabel="seleziona"
                                                        SelectedLabel="selezionato"
                                                        DeselectLabel="deseleziona"
                                                        id="digiters"
                                                        name="digiters"
                                                        :disabled="disabled"
                                                        :clear-on-select="false"
                                                        :searchable="true"
                                                        @search-change="personsFind">
                                                </multiselect>

                                            </div>
                                        </div>
                                    </div>


                                    <div class="row">
                                        <div class="col-md-12">
                                            <h4>Difetti di ripresa</h4>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="sovraesposizione">Sovraesposizione</label>
                                                <select v-model="reel.digitazion.data.sovraesposizione"
                                                        class="form-control"
                                                        id="sovraesposizione"
                                                        name="sovraesposizione" :disabled="disabled">
                                                    <option></option>
                                                    <option v-for="(fault, id) in faults"
                                                            v-bind:value="id">
                                                        {{ fault }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="sottoesposizione">Sottoesposizione</label>
                                                <select v-model="reel.digitazion.data.sottoesposizione"
                                                        class="form-control"
                                                        id="sottoesposizione"
                                                        name="sottoesposizione" :disabled="disabled">
                                                    <option></option>
                                                    <option v-for="(fault, id) in faults"
                                                            v-bind:value="id">
                                                        {{ fault }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="sfocature">Sfocature</label>
                                                <select v-model="reel.digitazion.data.sfocature" class="form-control"
                                                        id="sfocature"
                                                        name="sfocature" :disabled="disabled">
                                                    <option></option>
                                                    <option v-for="(fault, id) in faults"
                                                            v-bind:value="id">
                                                        {{ fault }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="stabilita">Stabilità di ripresa</label>
                                                <select v-model="reel.digitazion.data.stabilita" class="form-control"
                                                        id="stabilita"
                                                        name="stabilita" :disabled="disabled">
                                                    <option></option>
                                                    <option v-for="(desc, id) in shootingStability"
                                                            v-bind:value="id">
                                                        {{ desc }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="difetti_note">Note</label>
                                                <textarea v-model="reel.digitazion.data.difetti_note"
                                                          class="form-control"
                                                          id="difetti_note"
                                                          name="difetti_note"
                                                          :disabled="disabled"></textarea>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="faultAnalyzers">Operatore/i</label>
                                                <multiselect
                                                        v-model="reel.digitazion.data.faultAnalyzers.data"
                                                        :options="persons"
                                                        :multiple="true"
                                                        track-by="id"
                                                        label="nome"
                                                        placeholder="seleziona"
                                                        SelectLabel="seleziona"
                                                        SelectedLabel="selezionato"
                                                        DeselectLabel="deseleziona"
                                                        id="faultAnalyzers"
                                                        name="faultAnalyzers"
                                                        :disabled="disabled"
                                                        :clear-on-select="false"
                                                        :searchable="true"
                                                        @search-change="personsFind">
                                                </multiselect>

                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <!--image handle-->
                                <div class="col-md-6" v-if="showLabels">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <ul id="restorationgallery">
                                                <li v-for="image in reel.restoration.data.restorationimages.data">
                                                    <a :href="image.url" target="_blank">
                                                        <img :src="image.url"
                                                             class="img-responsive"/>
                                                    </a>

                                                    <button class="btn btn-xs btn-danger"
                                                            v-on:click.prevent="delRestorationImage(image.id)"
                                                            v-show="!disabled">
                                                        <i class="fa fa-remove"></i>
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <dropzone :style="{ border: '2px dashed', height: '200px', width: '100%' }"
                                                      :uploader="restorationImageUploader" v-show="!disabled"/>
                                            <span class="text-bold"
                                                  v-show="!disabled">Trascina qui i file da caricare</span>
                                        </div>
                                    </div>
                                </div>
                                <!--/.image-handle-->
                            </div>
                            <!-- /.tab-pane -->
                        </div>
                        <!-- /.tab-content -->

                      <div class="tab-pane" id="tab_3">

                        <div class="row">
                          <div class="col-md-6">

                            <div class="row">
                              <div class="col-md-12">
                                <div class="form-group">
                                  <label for="nome">Da pubblicare?</label>
                                  <input type="radio" name="web_enabled" value="0" v-model="reel.web_enabled"
                                         :disabled="disabled"/> No
                                  <input type="radio" name="web_enabled" value="1" v-model="reel.web_enabled"
                                         :disabled="disabled"/> Sì
                                </div>
                              </div>
                            </div>

                            <div class="row">
                              <div class="col-md-12">
                                <div class="form-group">
                                  <label for="web_note">Immagine in evidenza</label>
                                  <div class="row">
                                    <div class="col-md-4" v-for="image in reel.reelimages.data">
                                      <a :href="image.url" target="_blank">
                                        <img :src="image.url"
                                             class="img-responsive" style="width: 100%;"/>
                                      </a>
                                      <input type="radio" name="web_top_image" v-model="reel.web_top_image" :value="image.id" :disabled="disabled">
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="row">
                              <div class="col-md-12">
                                <button class="btn btn-warning btn-block" v-on:click.prevent="saveArchiveWeb"
                                        v-if="disabled && $accessControl.isOperator($store.state.profile.profile)">
                                  Salva info archivio web
                                </button>
                              </div>
                            </div>

                          </div>

                          <div class="col-md-6">
                          </div>
                        </div>
                      </div>

                        <div class="box-footer">
                            <ul class="nav">
                                <li class="pull-right" v-show="showSave">
                                    <button class="btn btn-success btn-block" v-if="!disabled"
                                            v-on:click.prevent="save">
                                        <i class="fa fa-circle-o-notch fa-spin" v-if="loader"></i>
                                        Salva
                                    </button>

                                    <button class="btn btn-warning btn-block" v-on:click.prevent="activateMod"
                                            v-if="disabled && $accessControl.isOperator($store.state.profile.profile)">
                                        Attiva modifiche
                                    </button>
                                </li>
                                <li class="pull-right" v-show="showSearch">
                                    <button class="btn btn-success btn-block" v-if="!disabled"
                                            v-on:click.prevent="search">
                                        <i class="fa fa-circle-o-notch fa-spin" v-if="loader"></i>
                                        Cerca
                                    </button>
                                </li>
                            </ul>
                        </div>

                    </div>
                    <!-- nav-tabs-custom -->
                </div>
            </div>
        </div>
    </form>
</template>

<script>
  import {clientDateFormat} from '../../filters'
  import personsApi from '../../api/persons'
  import reelsApi from '../../api/reels'
  import FineUploaderTraditional from 'fine-uploader-wrappers'
  import Dropzone from 'vue-fineuploader/dropzone'

  // Import this component
  import datePicker from 'vue-bootstrap-datetimepicker'

  // Import date picker css
  import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css'

  import Multiselect from 'vue-multiselect'
  import 'vue-multiselect/dist/vue-multiselect.min.css'

  import Description from '../components/Description.vue'

  import MaskedInput from 'vue-masked-input'
  import filmformatApi from '../../api/filmformat'
  import filmbrandApi from '../../api/filmbrand'

  export default {
    props: ['disabled', 'reel', 'loader', 'showLabels', 'showSearch', 'showSave'],
    methods: {
      save () {
        this.reel.fund_id = this.fund.id
        this.$emit('click', this.reel)
      },
      error (e) {
        console.log(e)
      },
      activateMod () {
        this.$emit('activate-mod', this.reel)
      },
      saveArchiveWeb () {
        this.$emit('save-archive-web', this.fund)
      },
      search () {
        this.$emit('search', this.fund)
      },
      delImage (id) {
        reelsApi.deleteImage(this.reel.id, id)
          .then((response) => {
            this.reel.reelimages = response.data.data.reelimages
            toastr.success('L\'immagine è stata rimossa correttamente')
          })
          .catch((response) => {
          })
      },
      delRestorationImage (id) {
        reelsApi.deleteRestorationImage(this.reel.restoration.data.id, id)
          .then((response) => {
            this.reel.restoration.data.restorationimages.data = response.data.data.restorationimages.data
            toastr.success('L\'immagine è stata rimossa correttamente')
          })
          .catch((response) => {
          })
      },
      personsFind (query) {
        personsApi.select(query)
          .then((response) => {
            this.persons = response.data.data
          })
      }
    },

    data () {
      return {
        config: {
          format: clientDateFormat
        },
        persons: [],
        formati: [],
        brands: [],
        uploader: new FineUploaderTraditional({
          options: []
        }),
        restorationImageUploader: new FineUploaderTraditional({
          options: []
        })
      }
    },

    watch: {
      reel: function (val) {
        this.uploader = new FineUploaderTraditional({
          options: {
            request: {
              endpoint: process.env.BASE_URL + '/reels/' + val.id + '/reelimage',
              customHeaders: {
                'Authorization': 'Bearer ' + sessionStorage.getItem('access_token')
              },
              inputName: 'image'
            },
            callbacks: {
              onComplete: (id, name, response) => {
                this.reel.reelimages = response.data.reelimages
              }
            }
          }
        })

        this.restorationImageUploader = new FineUploaderTraditional({
          options: {
            request: {
              endpoint: process.env.BASE_URL + '/restorations/' + val.restoration.data.id + '/restorationimage',
              customHeaders: {
                'Authorization': 'Bearer ' + sessionStorage.getItem('access_token')
              },
              inputName: 'image'
            },
            callbacks: {
              onComplete: (id, name, response) => {
                this.reel.restoration.data.restorationimages = response.data.restorationimages
              }
            }
          }
        })
      }
    },

    computed: {
      formato_tipi () {
        return this.$store.state.decoder.decoders['_dReelFormat']
      },
      freq1 () {
        return this.$store.state.decoder.decoders['_dFreq1']
      },
      freq2 () {
        return this.$store.state.decoder.decoders['_dFreq2']
      },
      velocity () {
        return this.$store.state.decoder.decoders['_dVelocity']
      },
      filmBrands () {
        return this.$store.state.decoder.decoders['_dFilmBrand']
      },
      audio () {
        return this.$store.state.decoder.decoders['_dAudio']
      },
      joints () {
        return this.$store.state.decoder.decoders['_dJoints']
      },
      fund () {
        return this.$store.state.ui.actualFund
      },
      faults () {
        return this.$store.state.decoder.decoders['_dFaults']
      },
      cromatismi () {
        return this.$store.state.decoder.decoders['_dColor']
      },
      ynp () {
        return this.$store.state.decoder.decoders['_dYesNoPartial']
      },
      shootingStability () {
        return this.$store.state.decoder.decoders['_dShootingStability']
      },
      longitudinalNarrowing () {
        return this.$store.state.decoder.decoders['_dLongitudinalNarrowing']
      }
    },

    beforeCreate () {
      filmformatApi.index()
        .then((response) => {
          this.formati = response.data.data
        })
      filmbrandApi.index()
        .then((response) => {
          this.brands = response.data.data
        })
    },

    components: {
      datePicker,
      Multiselect,
      Description,
      Dropzone,
      MaskedInput
    }
  }
</script>

<style scoped>
    .tab-pane h4 {
        background-color: #f7f7f7;
        font-size: 18px;
        text-align: center;
        padding: 7px 10px;
        margin-top: 0;
    }

    .tab-pane h4 {
        background-color: rgb(202, 94, 66);
    }

    #gallery, #restorationgallery {
        position: relative;
        padding: 0px;
    }

    #gallery li, #restorationgallery li {
        list-style: none;
        position: relative;
        margin-bottom: 10px;
    }

    #gallery button, #restorationgallery button {
        position: absolute;
        bottom: 0px;
        right: 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/reels/Form.vue